import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-turnoff-dark",
  "use": "icon-turnoff-dark-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-turnoff-dark\"><path d=\"M384 192.512v92.245333a298.666667 298.666667 0 1 0 256 0V192.512a384 384 0 1 1-256 0zM554.666667 85.333333v469.333334h-85.333334V85.333333h85.333334z\" fill=\"#2c2c2c\" p-id=\"5589\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol